import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
        {
            path: '/',
            name: 'home',
            meta: { name: '中小学在线一对一辅导教育平台', isFullScreen: true },
            component: () =>
                import('@/views/index/components/HomePage_new')
        },
        // 下载页
        {
            path: '/download',
            name: 'download',
            meta: { name: '下载页', isFullScreen: true },
            component: () =>
                import('@/views/index/components/DownLoad')
        },
        // 隐私政策
        {
            path: '/privacy-agreement',
            name: 'privacy-agreement',
            meta: { name: '隐私政策', isFullScreen: true },
            component: () =>
                import('@/views/index/components/PrivacyAgreement')
        },
        // 用户协议
        {
            path: '/user-agreement',
            name: 'user-agreement',
            meta: { name: '用户协议', isFullScreen: true },
            component: () =>
                import('@/views/index/components/UserAgreement')
        },
        // 儿童隐私政策
        {
            path: '/child-privary-policy',
            name: 'child-privary-policy',
            meta: { name: '儿童隐私政策', isFullScreen: true },
            component: () =>
                import('@/views/index/components/ChildPrivaryPolicy')
        },
        // 备案承诺公示
        {
            path: '/publicity-commitment',
            name: 'publicityCommitment',
            meta: { name: '备案承诺公示', isFullScreen: true },
            component: () =>
                import('@/views/index/components/PublicityCommitment')
        },
        // 教师信息页
        {
            path: '/teacherInfo',
            name: 'teacherInfo',
            meta: { name: '教师信息页', isFullScreen: true },
            component: () =>
                import('@/views/index/components/TeacherInfo')
        },
        // 登录页
        {
            path: '/account',
            component: () =>
                import('@/views/index/components/AccountPage'),
            children: [
                {
                    path: 'login',
                    name: 'login@account',
                    meta: { name: '登录', isFullScreen: true },
                    component: () =>
                        import('@/views/index/components/AccountLogin')
                },
                {
                    path: 'register',
                    name: 'register@account',
                    meta: { name: '注册', isFullScreen: true, illustrations: true },
                    component: () =>
                        import('@/views/index/components/AccountRegister')
                },
                {
                    path: 'find',
                    name: 'find@account',
                    meta: { name: '找回密码', isFullScreen: true, illustrations: true },
                    component: () =>
                        import('@/views/index/components/AccountFind')
                }
            ]
        },
        // 我的辅导
        {
            path: '/course/schedule',
            name: 'schedule@course',
            meta: { name: '我的辅导' },
            component: () =>
                import('@/views/index/components/CourseSchedule')
        },
        {
            path: '/course/plan',
            name: 'plan@course',
            meta: { name: '课程规划' },
            component: () =>
                import('@/views/index/components/CoursePlan')
        },
        // 课程规划下 正式、试听报告
        {
            path: '/course/report',
            name: 'report@course',
            meta: { name: '课后报告' },
            component: () =>
                import('@/views/index/components/CourseReport')
        },
        // 视频回放列表
        {
            path: '/course/video',
            name: 'video@course',
            meta: { name: '视频回放' },
            component: () =>
                import('@/views/index/components/CourseVideo')
        },
        // 视频回放详情
        {
            path: '/course/video/detail',
            name: 'videoDetail@course',
            meta: { name: '视频回放详情' },
            component: () =>
                import('@/views/index/components/CourseVideoDetail')
        },
        // 消费记录
        {
            path: '/record/tuition',
            name: 'tuition@record',
            meta: { name: '我的余额' },
            component: () =>
                import('@/views/index/components/RecordTuition')
        },
        // 充值学费
        {
            path: '/record/charge',
            name: 'charge@record',
            meta: { name: '充值学费' },
            component: () =>
                import('@/views/index/components/RecordCharge')
        },
        // 课时包购买
        {
            path: '/package/charge',
            name: 'charge@package',
            meta: {
                name: '课时包购买'
            },
            component: () =>
                import('@/views/index/components/PackageCharge')
        },
        {
            path: '/package/detail',
            name: 'detail@package',
            meta: {
                name: '课时包购买'
            },
            component: () => import('@/views/index/components/PackageDetail.vue')
        },
        // 充值反馈（学费，豆豆）是否成功
        {
            path: '/record/payback',
            name: 'payback@record',
            meta: { name: '充值反馈' },
            component: () =>
                import('@/views/index/components/RecordPayBack')
        },
        {
            path: '/record/period',
            name: 'period@record',
            meta: { name: '我的课时' },
            component: () =>
                import('@/views/index/components/RecordPeriod')
        },
        {
            path: '/record/purchase',
            name: 'purchase@record',
            meta: { name: '购买课时' },
            component: () =>
                import('@/views/index/components/RecordPurchase')
        },
        {
            path: '/record/packagelist',
            name: 'packageList@record',
            meta: { name: '购买课时' },
            component: () =>
                import('@/views/index/components/RecordPackageList')
        },
        {
            path: '/record/bean',
            name: 'bean@record',
            meta: { name: '我的豆豆' },
            component: () =>
                import('@/views/index/components/RecordBean')
        },
        {
            path: '/record/integral',
            name: 'integral@record',
            meta: { name: '我的积分' },
            component: () =>
                import('@/views/index/components/RecordIntegral')
        },
        // 账号信息
        {
            path: '/user/basic',
            name: 'basic@user',
            meta: { name: '个人信息' },
            component: () =>
                import('@/views/index/components/UserBasic')
        },
        {
            path: '/user/bind',
            name: 'bind@user',
            meta: { name: '绑定手机' },
            component: () =>
                import('@/views/index/components/UserBind')
        },
        {
            path: '/user/password',
            name: 'password@user',
            meta: { name: '修改密码' },
            component: () =>
                import('@/views/index/components/UserPassword')
        },
        // 404
        {
            path: '*',
            name: 'notFound',
            meta: { name: '404' },
            component: () =>
                import('@/views/index/components/NotFound')
        }
    ]
});

router.beforeEach((to, from, next) => {
    // if (to.meta.name) {
    //     document.title = '好分数辅导-' + to.meta.name;
    // } else {
    //     document.title = '好分数辅导';
    // }
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/views/index/router/index.js